export default function simpleTimezone(date) {
    const offset = date.toFormat('ZZZZ');

    switch (offset) {
        case 'CDT':
        case 'CST':
            return 'CT';

        case 'EDT':
        case 'EST':
            return 'ET';

        case 'MDT':
        case 'MST':
            return 'MT';

        case 'PDT':
        case 'PST':
            return 'PT';

        default:
            return offset;
    }
}
